import * as http from '../http';

export default {

  getConf() {
    return http.HTTP_CONF.get('/front_conf.json')
      .then(response => response.data);
  },
};



// WEBPACK FOOTER //
// ./src/utils/auth.js